import { render } from "./PostCard.vue?vue&type=template&id=6ce086c4&scoped=true"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"

import "./PostCard.vue?vue&type=style&index=0&id=6ce086c4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce086c4"]])

export default __exports__